interface IsStatusAllowProps {
  status: string;
  role?: "isTax" | "isEngineer";
}

export function isStatusAllow({ status, role }: IsStatusAllowProps): boolean {
  const allowedStatusesTax = [
    "PENDENTE_VALIDACAO_FISCAL",
    "ENTREGUE_SAP",
    "EM_ANALISE",
    "FINALIZADO",
    "RECLASSIFICADO",
  ];

  const allowedStatusesEngineer = [
    "ENTREGUE_SAP",
    "PENDENTE_VALIDACAO_FISCAL",
    "RECLASSIFICADO",
    "PENDENTE_VALIDACAO_FISCAL",
    "FINALIZADO",
  ];

  if (role === "isTax") {
    return allowedStatusesTax.includes(status);
  }

  if (role === "isEngineer") {
    return allowedStatusesEngineer.includes(status);
  }

  return false;
}

export function isStatusAllowNaladi({ status }: IsStatusAllowProps): boolean {
  const allowedStatusesTaxNaladi = [
    "PENDENTE_VALIDACAO_FISCAL",
    "EM_ANALISE",
    "FINALIZADO",
    "RECLASSIFICADO",
  ];

  return allowedStatusesTaxNaladi.includes(status);
}
